import {Dispatch} from 'react'
import * as http from '../../api/http'
import {ENDPOINTS} from '../../api/config'
import {generalOpenModalError, generalShowLoader} from '../general.actions'

/**
 * Trazabilidad de un documento que paso por contingencia: por que quedo en contingencia,
 * cuantos intentos se hicieron contra Hacienda, bajo que evento se informo y dentro de que
 * plazos. Es lo que se le muestra a Hacienda si pregunta.
 */
export const getTrazabilidadContingencia =
  (codigoGeneracion: string) => async (dispatch: Dispatch<any>) => {
    dispatch(generalShowLoader(true))

    try {
      const respuesta: any = await http.get(
        `${ENDPOINTS.GET_CONTINGENCIA_TRAZABILIDAD}/${codigoGeneracion}`
      )

      return respuesta?.body ?? null
    } catch (error: any) {
      dispatch(
        generalOpenModalError(
          error?.message ?? 'No se pudo obtener la bitácora de contingencia del documento.'
        )
      )
      return null
    } finally {
      dispatch(generalShowLoader(false))
    }
  }

/**
 * Documento firmado para reimprimir. El de contingencia se entrego al receptor sin sello de
 * recepcion; el certificado es el que Hacienda sello despues, al recibir el lote.
 */
export const getDocumentoContingencia =
  (codigoGeneracion: string, tipo: 'contingencia' | 'certificado') =>
  async (dispatch: Dispatch<any>) => {
    dispatch(generalShowLoader(true))

    try {
      const respuesta: any = await http.get(
        `${ENDPOINTS.GET_CONTINGENCIA_DOCUMENTO}/${codigoGeneracion}/${tipo}`
      )

      return respuesta?.body ?? null
    } catch (error: any) {
      dispatch(
        generalOpenModalError(
          error?.message ??
            (tipo === 'certificado'
              ? 'El documento todavía no ha sido certificado por Hacienda.'
              : 'El documento no tiene versión de contingencia.')
        )
      )
      return null
    } finally {
      dispatch(generalShowLoader(false))
    }
  }
